(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lt-christmas-tab"] && !Shopify.designMode) return;
  try {
    
$(function() {
  const section = $('.lt-christmas-tab');
  section.each(function() {
    const container = $(this).find('.tabs');
    const nav = container.find('.tab-item.active');
    const line = container.find('.tabs-line-active');
    const fWidth = container.width();
    const flkty = $(this).find('.flickityt4s').data('flickityt4s');
    function changeFlkty(idx) {
      flkty.selectCell(idx);
    }

    function setNav(nav) {
      const {left} = nav.position();
      const clipLeft = left;
      const clipRight = left + nav.width();
      const start = Number(100 - (clipRight / fWidth) * 100).toFixed();
      const end = Number((clipLeft / fWidth) * 100).toFixed();

      line.css('clipPath', `inset(0 ${start}% 0 ${end}% round var(--rd))`);
    }

    container.find('.tab-item').on('click', function() {
      container.find('.tab-item.active').removeClass('active');
      $(this).addClass('active');
      const idx = $(this).data('idx');
      setNav($(this));
      changeFlkty(idx);
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-videos"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    const maxH = $('.lt-videos .carousel-videos .w__CustomVideo').outerHeight() * 3 + 20 * 2;
    const container = $('.lt-videos .carousel-videos');
    const defaultH = container.height();
    let isExpand = false;
    container.css('height', maxH + 'px');
    $('.lt-videos .more').on('click', function () {
      const newH = isExpand ? maxH : defaultH;
      isExpand = !isExpand;
      container.animate({ height: newH + 'px' });
      $(this)
        .find('span')
        .text(isExpand ? 'Collapse more' : 'Expand more');
      $(this).toggleClass('expand');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quickshop-modal"]) return;
  try {
    
  (function () {
    'use strict';

    /*
     * 运行时说明：
     *   V2 里这三个自定义元素都由 assets/cart-component.js 定义。bf26 没有那个文件，
     *   所以 cart-item-stepper / product-picker-modal 在这里做同名实现；
     *   variant-switcher 复用 bf26 b2g.js 里已有的那个（它只认 B2G 的数据源，读到
     *   这里的变体 JSON 为空会自行 return，不干扰下面的联动）。
     *   合并新版购物车后，本段整段删掉，交给 cart-component.js。
     */

    var QTY_EVENT = 'cart-item:qty-change';

    /* ── 数量步进器 <cart-item-stepper> ───────────────────────────────── */
    if (!customElements.get('cart-item-stepper')) {
      customElements.define(
        'cart-item-stepper',
        class extends HTMLElement {
          connectedCallback() {
            if (this._ready) return;
            this._ready = true;

            this.input = this.querySelector('[data-quantity-value]');
            this.decBtn = this.querySelector('[data-decrease-qty]');
            this.incBtn = this.querySelector('[data-increase-qty]');

            this.min = this.num('data-min', 1);
            this.max = this.num('data-max', 9999);
            this.step = this.num('data-step', 1) || 1;

            /*
             * 必须掐掉冒泡：bf26 的 assets/interactable.min.js 在 document 上做了事件委托
             *   s.on('click', '[data-quantity-selector]', …)
             *   s.on('change', '[data-quantity-value]', …)
             * 它会读 [data-quantity-value] 的当前值自行 ±step。本文件为与 V2 保持一致用的正是
             * 这套属性名，于是同一次点击跑两遍：这里先 1→2 并写回 input，委托再读到 2→3，
             * 症状就是「点一下加号跳到 3」。属性名不动，改在控件上掐冒泡。
             */
            if (this.decBtn) {
              this.decBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.jump(-1);
              });
            }
            if (this.incBtn) {
              this.incBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.jump(1);
              });
            }
            if (this.input) {
              // 手输时夹取；set() 只改 value，不会再触发 change，所以不会递归
              this.input.addEventListener('change', (e) => {
                e.stopPropagation();
                var v = parseFloat(this.input.value);
                this.set(isNaN(v) ? this.min : this.clamp(v), true);
              });
            }

            this.sync(false);
          }

          num(attr, fallback) {
            var v = parseFloat(this.getAttribute(attr));
            return isNaN(v) ? fallback : v;
          }

          get value() {
            var v = parseFloat(this.getAttribute('data-value'));
            if (!isNaN(v)) return this.clamp(v);
            return this.input ? parseFloat(this.input.value) || this.min : this.min;
          }

          clamp(v) {
            if (v < this.min) v = this.min;
            if (v > this.max) v = this.max;
            return v;
          }

          jump(dir) {
            var next = this.clamp(this.value + dir * this.step);
            if (next === this.value) return;
            this.set(next, true);
          }

          set(v, emit) {
            this.setAttribute('data-value', String(v));
            this.sync(emit);
          }

          sync(emit) {
            if (this._syncing) return;
            this._syncing = true;

            var v = this.value;
            this.setAttribute('data-value', String(v));
            if (this.input) {
              this.input.value = String(v);
              this.input.setAttribute('value', String(v));
            }
            if (this.decBtn) this.decBtn.disabled = v <= this.min;
            if (this.incBtn) this.incBtn.disabled = v >= this.max;

            this._syncing = false;

            if (emit) {
              this.dispatchEvent(new CustomEvent(QTY_EVENT, { bubbles: true, detail: { value: v } }));
            }
          }
        }
      );
    }

    /* ── 弹窗主体 <product-picker-modal> ──────────────────────────────── */
    if (!customElements.get('product-picker-modal')) {
      customElements.define(
        'product-picker-modal',
        class extends HTMLElement {
          connectedCallback() {
            if (this._ready) return;
            this._ready = true;

            this.addEventListener('click', (e) => this.onClick(e));

            var el = this.querySelector('[data-cart-variants-json]');
            try {
              this.variants = el ? JSON.parse(el.textContent) : [];
            } catch (_) {
              this.variants = [];
            }

            this.refreshAvailability();
            // 初始选中变体本身可能就无库存（全部缺货时 selected_or_first_available_variant 会落回第一个变体）
            this.syncConfirmState();
          }

          get variantId() {
            var v = parseInt(this.getAttribute('data-variant-id'), 10);
            return isNaN(v) ? null : v;
          }

          /* 当前选中变体在 variants JSON 里的记录；取不到返回 null（不擅自当作缺货） */
          currentVariant() {
            var id = this.variantId;
            if (!id) return null;
            for (var i = 0; i < this.variants.length; i++) {
              if (this.variants[i].id === id) return this.variants[i];
            }
            return null;
          }

          /* 当前选中：直接读服务端渲染出来的 is-active */
          selected() {
            var out = {};
            this.querySelectorAll('[data-pdp-option]').forEach((opt) => {
              var active = opt.querySelector('[data-pdp-swatch].is-active');
              if (active) out[opt.getAttribute('data-option-index')] = active.getAttribute('data-value');
            });
            return out;
          }

          /* 选中组合精确匹配的变体 */
          findVariant(sel) {
            var keys = Object.keys(sel);
            for (var i = 0; i < this.variants.length; i++) {
              var ok = true;
              for (var k = 0; k < keys.length; k++) {
                if (this.variants[i]['option' + (parseInt(keys[k], 10) + 1)] !== sel[keys[k]]) {
                  ok = false;
                  break;
                }
              }
              if (ok) return this.variants[i];
            }
            return null;
          }

          /* 该值在其它选项当前取值下是否有货 —— 对应 pdp-pf-option 的 is-soldout / is-cross */
          availability(opt, value) {
            var idx = parseInt(opt.getAttribute('data-option-index'), 10);
            var others = this.selected();
            delete others[opt.getAttribute('data-option-index')];

            var cross = false;
            for (var i = 0; i < this.variants.length; i++) {
              var v = this.variants[i];
              if (v['option' + (idx + 1)] !== value) continue;

              var matches = true;
              for (var key in others) {
                if (v['option' + (parseInt(key, 10) + 1)] !== others[key]) {
                  matches = false;
                  break;
                }
              }
              if (matches) {
                if (v.available) return 'available';
              } else if (v.available) {
                cross = true;
              }
            }
            return cross ? 'cross' : 'soldout';
          }

          refreshAvailability() {
            this.querySelectorAll('[data-pdp-option]').forEach((opt) => {
              opt.querySelectorAll('[data-pdp-swatch]').forEach((btn) => {
                var state = this.availability(opt, btn.getAttribute('data-value'));
                btn.classList.toggle('is-soldout', state === 'soldout');
                btn.classList.toggle('is-cross', state === 'cross');
                if (state === 'available') btn.removeAttribute('aria-disabled');
                else btn.setAttribute('aria-disabled', 'true');
              });
            });
          }

          onClick(e) {
            var btn = e.target.closest('[data-pdp-swatch]');
            if (!btn || !this.contains(btn)) return;

            var opt = btn.closest('[data-pdp-option]');
            if (!opt) return;

            var idx = parseInt(opt.getAttribute('data-option-index'), 10);
            var value = btn.getAttribute('data-value');

            // 该值在其它选项当前取值下完全无货 → 点不动
            if (this.availability(opt, value) === 'soldout') return;

            var variant = this.resolve(idx, value);
            if (!variant) return;

            this.applySelection(variant);
            this.refreshAvailability();
          }

          /*
           * 定出点击后要落的变体：
           *   能精确命中且可售 → 就用它；
           *   否则优先保留刚点的那个值（Pink 缺货时换 Size，Size 缺货时换 Color），
           *   在可售变体里挑与当前其余选项最接近的一个。
           * 这就是 V2 里「点 is-cross 的色 → 落到最近可售组合」的行为。
           */
          resolve(anchorIdx, anchorValue) {
            var sel = this.selected();
            sel[String(anchorIdx)] = anchorValue;

            var exact = null;
            var best = null;

            for (var i = 0; i < this.variants.length; i++) {
              var cand = this.variants[i];
              if (!cand.available) continue;
              if (cand['option' + (anchorIdx + 1)] !== anchorValue) continue;

              var score = 0;
              var complete = true;
              for (var key in sel) {
                var optValue = cand['option' + (parseInt(key, 10) + 1)];
                if (optValue !== sel[key]) complete = false;
                else if (key !== String(anchorIdx)) score++;
              }
              if (complete) {
                exact = cand;
                break;
              }
              if (!best || score > best.score) best = { variant: cand, score: score };
            }

            return exact || (best && best.variant) || null;
          }

          /* 把变体回写到 UI：选中态 + 选项头的当前值 */
          applySelection(variant) {
            this.querySelectorAll('[data-pdp-option]').forEach((opt) => {
              var idx = parseInt(opt.getAttribute('data-option-index'), 10);
              var target = variant['option' + (idx + 1)];

              opt.querySelectorAll('[data-pdp-swatch]').forEach((b) => {
                var on = b.getAttribute('data-value') === target;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-pressed', on ? 'true' : 'false');
              });

              var label = opt.querySelector('[data-pdp-current-value]');
              if (label && target != null) label.textContent = target;
            });

            this.apply(variant);
          }

          apply(variant) {
            this.setAttribute('data-variant-id', String(variant.id));

            var img = this.querySelector('[data-product-img]');
            if (img && variant.featured_image && variant.featured_image.src) {
              img.src = variant.featured_image.src;
            }

            var price = this.querySelector('[data-product-price]');
            if (price) price.textContent = this.money(variant.price, true);

            var compare = this.querySelector('[data-product-compare-price]');
            if (compare) {
              var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
              compare.textContent = hasCompare ? this.money(variant.compare_at_price, false) : '';
              compare.classList.toggle('is-hidden', !hasCompare);
            }

            // 选中变体的可售性同步到属性上（单变体商品没有 variants JSON，只能靠服务端这个值）
            this.setAttribute('data-variant-available', variant.available === false ? 'false' : 'true');

            // 切到无库存变体时，确认按钮要立刻回到禁用态
            this.syncConfirmState();

            this.dispatchEvent(
              new CustomEvent('quickshop:variant-change', { bubbles: true, detail: { variant: variant } })
            );
          }

          /*
           * 无库存的变体不允许加入清单 —— 同步弹窗 footer 的确认按钮（Add to Wishlist）。
           * 按钮由 snippets/dsm-modal.liquid 用 dsm-button 渲染（类 .js-dsm-dialog-confirm），
           * 禁用 / 解除都走 disabled + aria-disabled + dsm-btn--disabled（与 DSM 禁用态一致），
           * 同时把 aria-label / title 换成缺货文案，读屏与悬停能知道为什么点不动。
           * 数据源两级：多变体商品读 data-cart-variants-json 里当前变体的 available；
           * 单变体商品没有那份 JSON（服务端只在 has_only_default_variant=false 时输出），
           * 退回服务端渲染的 data-variant-available。都拿不到时不禁用，避免把可售商品锁死。
           */
          syncConfirmState() {
            var variant = this.currentVariant();
            var soldOut;
            if (variant) soldOut = variant.available === false;
            else soldOut = this.getAttribute('data-variant-available') === 'false';

            this.setAttribute('data-soldout', soldOut ? 'true' : 'false');

            var overlay = this.closest('[data-dsm-dialog]');
            var btn = overlay ? overlay.querySelector('.js-dsm-dialog-confirm') : null;
            if (!btn) return;

            var soldOutLabel = this.getAttribute('data-soldout-label') || '';
            var baseLabel = btn.getAttribute('data-label') || btn.textContent.trim();
            if (baseLabel && !btn.getAttribute('data-label')) btn.setAttribute('data-label', baseLabel);

            btn.classList.toggle('dsm-btn--disabled', soldOut);
            if (soldOut) {
              btn.setAttribute('disabled', 'disabled');
              btn.setAttribute('aria-disabled', 'true');
            } else {
              btn.removeAttribute('disabled');
              btn.removeAttribute('aria-disabled');
            }

            if (soldOutLabel) {
              var label = soldOut ? soldOutLabel : baseLabel;
              btn.setAttribute('aria-label', label);
              btn.setAttribute('title', label);
            }
          }

          /* plain=true → 只要金额（对应 money_without_currency，与服务端渲染的整数位一致） */
          money(cents, plain) {
            var amount = (cents / 100).toFixed(2);
            if (plain) return amount;
            var fmt = this.getAttribute('data-money-format');
            if (!fmt) return '$' + amount;
            // 用 RegExp 构造函数写，避免双花括号出现在源码里被 Liquid 当成输出
            var token = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
            return fmt.replace(token, function (m, key) {
              if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') {
                return String(Math.round(cents / 100));
              }
              return amount;
            });
          }

          /* 接入方取用：确认时要提交的变体、数量与商品快照
             available=false → 该变体无库存，不应写入清单（接入方据此再兜一层）
             handle 供清单存储做商品快照用（未来活动页没有本 section / 商品目录 JSON 时靠它反查商品） */
          collect() {
            var stepper = this.querySelector('cart-item-stepper');
            var variant = this.currentVariant();
            // 单变体商品没有 variants JSON，退回服务端渲染的 data-variant-available
            var available = variant
              ? variant.available !== false
              : this.getAttribute('data-variant-available') !== 'false';
            return {
              cartKey: null,
              variantId: this.variantId,
              qty: stepper ? stepper.value : 1,
              available: available,
              handle: this.getAttribute('data-product-handle') || '',
            };
          }
        }
      );
    }

    /* ── 确认：只派事件，加购由接入方决定 ─────────────────────────────── */
    document.addEventListener('dsm:dialog:confirm', function (e) {
      var dialog = e.target && e.target.closest ? e.target.closest('[data-dsm-dialog]') : null;
      if (!dialog) dialog = document.getElementById('quickshop-modal');

      var picker = dialog ? dialog.querySelector('[data-quickshop]') : null;
      if (picker && picker.hasAttribute('data-qs-cart')) return;
      // 只在「派发事件的那个弹窗」里找 picker：不要退回 document.querySelector ——
      // 同页任何一个 dsm 弹窗点确认都会派发本事件，全局兜底会命中页面上静态的 quickshop 副本，
      // 白造一条 cart:variant-update，把清单里同一变体的数量 +n（bfw:wishlist:add 现在是累加语义）
      if (!picker || typeof picker.collect !== 'function') return;

      var detail = picker.collect();
      if (!detail.variantId) return;
      // 无库存变体不加清单：按钮已禁用，这里再兜一层（防其它入口派发 confirm）
      if (detail.available === false) return;

      picker.dispatchEvent(new CustomEvent('cart:variant-update', { bubbles: true, detail: detail }));
    });

    if (!customElements.get('qs-modal-trigger')) {
      var triggerCache = new Map();

      function getModalOverlay(modalId) {
        return (
          document.getElementById(modalId + '-overlay') ||
          document.querySelector('[data-dsm-dialog="' + CSS.escape(modalId) + '"]')
        );
      }

      function extractContent(html, sectionId, contentSel) {
        var fragment = new DOMParser().parseFromString(html, 'text/html');
        // 响应里可能包着 #shopify-section-<id>（没有时退回整个文档）
        var scope = fragment.getElementById('shopify-section-' + sectionId) || fragment;
        if (contentSel) {
          var picked = scope.querySelector(contentSel);
          return picked ? picked.innerHTML : html;
        }
        // 没传 content-sel 的兜底：先摘掉 section 自己的弹窗容器，避免「弹窗注入弹窗」
        var ownOverlay = scope.querySelector('[data-dsm-dialog]');
        if (ownOverlay) ownOverlay.remove();
        return scope === fragment ? fragment.body.innerHTML : scope.innerHTML;
      }

      function injectIntoModal(overlay, html, targetSel) {
        var target =
          (targetSel && overlay.querySelector(targetSel)) ||
          overlay.querySelector('.dsm-modal__content') ||
          overlay.querySelector('.dsm-modal__body') ||
          overlay;
        target.innerHTML = html;
      }

      /** 把响应里的样式表提到 head（按 id / href 去重），返回等待加载的 Promise */
      function hoistStyles(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var links = Array.prototype.slice.call(doc.querySelectorAll('link[rel="stylesheet"]'));
        var pending = [];
        links.forEach(function (link) {
          link.remove();
          var existing = link.id
            ? document.getElementById(link.id)
            : document.head.querySelector('link[href="' + link.href + '"]');
          if (existing) return;
          var hoisted = link.cloneNode();
          pending.push(
            new Promise(function (resolve) {
              hoisted.addEventListener('load', resolve, { once: true });
              hoisted.addEventListener('error', resolve, { once: true });
            })
          );
          document.head.appendChild(hoisted);
        });
        return { html: doc.body.innerHTML, promise: Promise.all(pending) };
      }

      class QsModalTrigger extends HTMLElement {
        connectedCallback() {
          if (this._ac) return;
          this._ac = new AbortController();
          this.addEventListener('click', this, { signal: this._ac.signal });
        }

        disconnectedCallback() {
          if (this._ac) this._ac.abort();
          this._ac = null;
        }

        get sectionId() {
          return this.getAttribute('section-id') || '';
        }

        get modalId() {
          return this.getAttribute('modal-id') || '';
        }

        get src() {
          return this.getAttribute('src') || window.location.href;
        }

        get contentSel() {
          return this.getAttribute('content-sel') || null;
        }

        get targetSel() {
          return this.getAttribute('target-sel') || null;
        }

        get loadingClass() {
          return this.getAttribute('loading-class') || 'is-loading';
        }

        get mode() {
          return this.getAttribute('mode') || '';
        }

        get confirmLabel() {
          return this.getAttribute('confirm-label') || '';
        }

        get useCache() {
          return this.getAttribute('cache') !== 'false';
        }

        handleEvent(event) {
          if (event.type === 'click') this._open(event);
        }

        _open(event) {
          if (this.classList.contains(this.loadingClass)) {
            event.preventDefault();
            return;
          }
          // 让内部真正的交互元素自己处理（与主题版行为一致）
          if (event.target.closest('a[href], button[type="submit"], input, select, textarea')) return;
          event.preventDefault();

          var sectionId = this.sectionId;
          var modalId = this.modalId;
          if (!sectionId || !modalId) {
            console.warn('<qs-modal-trigger>: section-id / modal-id 必填');
            return;
          }

          var overlay = getModalOverlay(modalId);
          if (!overlay) {
            console.warn('<qs-modal-trigger>: 找不到弹窗 "' + modalId + '"，请在使用页面的模板里挂载该 section');
            return;
          }

          this._setLoading(overlay, true);

          this._fetch(sectionId)
            .then(
              function (html) {
                // 先把整段响应里的样式表提到 head（按 href 去重），再只取内容槽注入
                var hoisted = hoistStyles(html);
                return hoisted.promise.then(
                  function () {
                    var content = extractContent(hoisted.html, sectionId, this.contentSel);
                    if (!content.trim()) {
                      this._setLoading(overlay, false);
                      console.warn(
                        '<qs-modal-trigger>: section "' + sectionId + '" 渲染内容为空（product 上下文缺失？）'
                      );
                      return;
                    }
                    injectIntoModal(overlay, content, this.targetSel);
                    this._apply(overlay);
                    this._setLoading(overlay, false);
                    this._openModal(modalId, overlay);
                  }.bind(this)
                );
              }.bind(this)
            )
            .catch(
              function (error) {
                this._setLoading(overlay, false);
                console.error('<qs-modal-trigger> 拉取 section 失败:', error);
              }.bind(this)
            );
        }

        _setLoading(overlay, loading) {
          overlay.classList.toggle(this.loadingClass, loading);
          this.classList.toggle(this.loadingClass, loading);
          var button = this.querySelector('.bfw-shop__add');
          if (!button) return;
          button.disabled = loading;
          if (loading) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        }

        _apply(overlay) {
          if (overlay._dsmOnConfirm) delete overlay._dsmOnConfirm;
          var picker = overlay.querySelector('[data-quickshop]');
          if (this.mode === 'cart' && picker) {
            picker.setAttribute('data-qs-cart', '');
            this.dispatchEvent(new CustomEvent('qs:cart-open', { bubbles: true, detail: { overlay: overlay } }));
          }

          var label = this.confirmLabel;
          if (!label) return;
          var btn = overlay.querySelector('.js-dsm-dialog-confirm');
          if (!btn) return;
          btn.setAttribute('data-label', label);
          btn.setAttribute('aria-label', label);
          var span = btn.querySelector('.dsm-btn__label');
          if (span) span.textContent = label;
          else btn.textContent = label;
          if (picker && typeof picker.syncConfirmState === 'function') picker.syncConfirmState();
        }

        _fetch(sectionId) {
          var url = new URL(this.src, window.location.origin);
          url.searchParams.set('section_id', sectionId);
          url.searchParams.sort();
          var href = url.toString();

          if (this.useCache && triggerCache.has(href)) {
            return Promise.resolve(triggerCache.get(href));
          }

          return fetch(href, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          })
            .then(function (response) {
              if (!response.ok) throw new Error('qs-modal-trigger: HTTP ' + response.status);
              return response.text();
            })
            .then(
              function (html) {
                if (this.useCache) triggerCache.set(href, html);
                return html;
              }.bind(this)
            );
        }

        _openModal(modalId, overlay) {
          if (window.DsmDialog) {
            window.DsmDialog.open(modalId);
            return;
          }
          // 兜底：.dsm-overlay 靠 .is-open 显示（hidden 属性不参与可见性）
          overlay.removeAttribute('hidden');
          overlay.classList.add('is-open');
        }
      }

      customElements.define('qs-modal-trigger', QsModalTrigger);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-brand-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * v3-brand-pdp-tabs 交互逻辑
     *
     * 动画时序：
     *   1. 锁定容器高度（文档流中准确读取）
     *   2. 设置 CSS 方向变量
     *   3. 退场面板加 is-leaving（初始可见态 opacity:1 translateX(0)）
     *   4. 进场面板加 is-active（初始偏移态 opacity:0 translateX(enterFrom)）
     *   5. 加 is-animating → 两个面板变 absolute，CSS 初始态生效
     *   6. rAF 双帧确保初始态已绘制，再加 is-leaving-active + is-entering 同步触发过渡
     *   7. 420ms 后清理所有状态类
     */

    function initTabsSection(sectionEl) {
      var prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var panelsWrap = sectionEl.querySelector('.v3-tabs__panels');
      var navWrap = sectionEl.querySelector('.v3-tabs__nav-wrap');
      var navEl = sectionEl.querySelector('.v3-tabs__nav');
      var navBtns = Array.prototype.slice.call(sectionEl.querySelectorAll('.v3-tabs__nav-btn'));
      var panels = Array.prototype.slice.call(sectionEl.querySelectorAll('.v3-tabs__panel'));

      if (!navBtns.length || !panels.length || !panelsWrap) return;

      var navIndicator = navEl ? navEl.querySelector('.v3-tabs__nav-indicator') : null;
      if (navEl && !navIndicator) {
        navIndicator = document.createElement('span');
        navIndicator.className = 'v3-tabs__nav-indicator';
        navIndicator.setAttribute('aria-hidden', 'true');
        navEl.insertBefore(navIndicator, navEl.firstChild);
      }

      var currentIndex = 0;
      var animating = false;
      var cleanupTimer = null;
      var rafOverflow = 0;

      function updateActiveIndicator(immediate) {
        if (!navEl || !navIndicator) return;
        var activeBtn = navBtns[currentIndex] || navEl.querySelector('.v3-tabs__nav-btn.is-active');
        if (!activeBtn) return;
        var navRect = navEl.getBoundingClientRect();
        var btnRect = activeBtn.getBoundingClientRect();
        var indicatorX = btnRect.left - navRect.left;
        if (immediate) navIndicator.style.transition = 'none';
        navEl.style.setProperty('--v3t-indicator-x', indicatorX + 'px');
        navEl.style.setProperty('--v3t-indicator-w', btnRect.width + 'px');
        if (immediate) {
          navIndicator.getBoundingClientRect();
          navIndicator.style.transition = '';
        }
      }

      function updateNavOverflow() {
        if (!navWrap || !navEl) return;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        if (vw > 768) {
          sectionEl.classList.remove('v3-tabs--nav-scroll');
          updateActiveIndicator(true);
          return;
        }
        var isOverflow = navEl.scrollWidth > navWrap.clientWidth + 1;
        sectionEl.classList.toggle('v3-tabs--nav-scroll', isOverflow);
        if (!isOverflow) navWrap.scrollLeft = 0;
        updateActiveIndicator(true);
      }

      /**
       * 将指定按钮滚动到 nav-wrap 可视区居中位置（仅 Mobile 横向滚动时生效）
       * @param {HTMLElement} btn
       */
      function scrollBtnIntoView(btn) {
        if (!navWrap || !navEl) return;
        // 只在 nav 实际超出 wrap 宽度时才滚动
        if (navEl.scrollWidth <= navWrap.clientWidth) return;
        var btnLeft = btn.offsetLeft;
        var btnWidth = btn.offsetWidth;
        var wrapWidth = navWrap.clientWidth;
        var targetScrollLeft = btnLeft - wrapWidth / 2 + btnWidth / 2;
        var maxScroll = Math.max(0, navWrap.scrollWidth - navWrap.clientWidth);
        if (targetScrollLeft < 0) targetScrollLeft = 0;
        if (targetScrollLeft > maxScroll) targetScrollLeft = maxScroll;
        navWrap.scrollTo({ left: targetScrollLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      }

      function getRenderableImgs(panelEl) {
        if (!panelEl) return [];
        var isMobile = (window.innerWidth || document.documentElement.clientWidth || 0) <= 768;
        var selector = isMobile ? '.v3-tabs__img--mob img' : '.v3-tabs__img--pc img';
        var imgs = panelEl.querySelectorAll(selector);
        if (imgs.length) return Array.prototype.slice.call(imgs);
        return Array.prototype.slice.call(panelEl.querySelectorAll('img'));
      }

      function getAllTabImgs() {
        return Array.prototype.slice.call(sectionEl.querySelectorAll('.v3-tabs__img-el'));
      }

      function updateImageSkeleton(img, loaded, errored) {
        var wrap = img && img.closest ? img.closest('.v3-tabs__img') : null;
        if (!wrap) return;
        wrap.classList.toggle('v3-tabs__img--loading', !loaded && !errored);
        wrap.classList.toggle('v3-tabs__img--loaded', loaded);
        wrap.classList.toggle('v3-tabs__img--error', errored);
      }

      function bindImageSkeletons(scopeEl) {
        var imgs = Array.prototype.slice.call((scopeEl || sectionEl).querySelectorAll('.v3-tabs__img-el'));
        imgs.forEach(function (img) {
          if (img.dataset.v3tabsSkeletonBound === '1') return;
          img.dataset.v3tabsSkeletonBound = '1';

          if (img.complete) {
            updateImageSkeleton(img, !!img.naturalWidth, !img.naturalWidth);
            return;
          }

          updateImageSkeleton(img, false, false);
          img.addEventListener('load', function () {
            updateImageSkeleton(img, true, false);
          }, { once: true });
          img.addEventListener('error', function () {
            updateImageSkeleton(img, false, true);
          }, { once: true });
        });
      }

      var allImagesPreloaded = false;
      function preloadAllTabImages() {
        if (allImagesPreloaded) return;
        allImagesPreloaded = true;
        var imgs = getAllTabImgs();
        imgs.forEach(function (img) {
          bindImageSkeletons(img.closest('.v3-tabs__panel') || sectionEl);

          try {
            img.loading = 'eager';
          } catch (ignore) {}

          if (img.complete) {
            updateImageSkeleton(img, !!img.naturalWidth, !img.naturalWidth);
            return;
          }

          var pre = new Image();
          pre.onload = function () {
            updateImageSkeleton(img, true, false);
          };
          pre.onerror = function () {
            updateImageSkeleton(img, false, true);
          };
          if (img.srcset) pre.srcset = img.srcset;
          if (img.sizes) pre.sizes = img.sizes;
          pre.src = img.currentSrc || img.src;
        });
      }

      function setupViewportPreload() {
        if (!('IntersectionObserver' in window)) {
          preloadAllTabImages();
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            preloadAllTabImages();
            observer.disconnect();
          });
        }, {
          root: null,
          rootMargin: '600px 0px',
          threshold: 0
        });

        observer.observe(sectionEl);
      }

      function isImgReady(img) {
        return !!(img && img.complete && img.naturalWidth);
      }

      function setPanelImageWaiting(panelEl, waiting) {
        if (!panelEl) return;
        panelEl.classList.toggle('is-image-waiting', waiting);
      }

      function preparePanelImageSkeleton(panelEl, forceWaiting) {
        if (!panelEl) return;
        bindImageSkeletons(panelEl);
        var imgs = getRenderableImgs(panelEl);
        var waiting = imgs.some(function (img) {
          return !isImgReady(img);
        });
        setPanelImageWaiting(panelEl, !!(forceWaiting && imgs.length) || waiting);
        imgs.forEach(function (img) {
          updateImageSkeleton(img, isImgReady(img), !!(img.complete && !img.naturalWidth));
        });
      }

      function clearPanelImageSkeletonWhenReady(panelEl, minDuration) {
        if (!panelEl) return;
        var startTime = Date.now();
        var imgs = getRenderableImgs(panelEl);
        if (!imgs.length) {
          setPanelImageWaiting(panelEl, false);
          return;
        }

        function refresh() {
          var stillWaiting = imgs.some(function (img) {
            return !img.complete;
          });
          var elapsed = Date.now() - startTime;
          if (!stillWaiting && minDuration && elapsed < minDuration) {
            setTimeout(refresh, minDuration - elapsed);
            return;
          }
          setPanelImageWaiting(panelEl, stillWaiting);
        }

        refresh();
        imgs.forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', refresh, { once: true });
          img.addEventListener('error', refresh, { once: true });
        });
      }

      function getPanelHeight(panelEl, fallbackHeight) {
        if (!panelEl) return fallbackHeight || 0;
        var panelHeight = panelEl.offsetHeight;
        if (panelHeight > 0) return panelHeight;
        var imageWrap = panelEl.querySelector('.v3-tabs__panel-img-wrap');
        var imageWrapHeight = imageWrap ? imageWrap.getBoundingClientRect().height : 0;
        return imageWrapHeight || fallbackHeight || panelsWrap.offsetHeight || 1;
      }

      function activateTab(nextIndex) {
        if (nextIndex === currentIndex || animating) return;
        animating = true;
        clearTimeout(cleanupTimer);

        var prevPanel = panels[currentIndex];
        var nextPanel = panels[nextIndex];
        var goRight = nextIndex > currentIndex;
        var prevH = getPanelHeight(prevPanel, panelsWrap.offsetHeight);

        if (nextPanel) {
          preparePanelImageSkeleton(nextPanel, true);
          var nextImgs = getRenderableImgs(nextPanel);
          nextImgs.forEach(function (img) {
            // 通过 new Image() 预取，不修改已解析的 loading 属性（修改无效）
            if (!img.complete) {
              var pre = new Image();
              if (img.srcset) pre.srcset = img.srcset;
              if (img.sizes) pre.sizes = img.sizes;
              pre.src = img.currentSrc || img.src;
            }
          });
        }

        // 更新按钮状态
        navBtns.forEach(function (btn, i) {
          var active = i === nextIndex;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.setAttribute('tabindex', active ? '0' : '-1');
        });
        currentIndex = nextIndex;
        updateActiveIndicator(false);

        // ① 锁定容器高度（prevPanel 还在文档流中，读取准确）
        panelsWrap.style.height = prevH + 'px';

        // ② 写入方向 CSS 变量
        panelsWrap.style.setProperty('--v3t-enter-from', goRight ? '72px' : '-72px');
        panelsWrap.style.setProperty('--v3t-leave-to', goRight ? '-72px' : '72px');

        // ③ 退场面板打标（此时还未加 is-animating，面板仍在文档流，CSS 初始态为可见）
        prevPanel.classList.add('is-leaving');

        // ④ 进场面板激活（移除 hidden 使 AT 可读，此时同样未加 is-animating）
        nextPanel.removeAttribute('hidden');
        nextPanel.classList.add('is-active');
        clearPanelImageSkeletonWhenReady(nextPanel, prefersReducedMotion ? 0 : 420);
        var nextH = getPanelHeight(nextPanel, prevH);

        // ⑤ 开启动画模式 → 两个面板变 absolute，CSS 初始态（退场可见/进场偏移）立即生效
        panelsWrap.classList.add('is-animating');

        requestAnimationFrame(function () {
          panelsWrap.style.height = nextH + 'px';
          nextPanel.getBoundingClientRect();
          prevPanel.getBoundingClientRect();
          requestAnimationFrame(function () {
            prevPanel.classList.add('is-leaving-active'); // 退场：滑出
            nextPanel.classList.add('is-entering'); // 进场：滑入
          });
        });

        // ⑦ 过渡结束后清理（transition 时长 0.2s，多留 30ms 余量）
        cleanupTimer = setTimeout(function () {
          prevPanel.classList.remove('is-active', 'is-leaving', 'is-leaving-active', 'is-entering');
          setPanelImageWaiting(prevPanel, false);
          prevPanel.setAttribute('hidden', '');  // 退场面板恢复 hidden，AT 不再读取
          nextPanel.classList.remove('is-entering');
          panelsWrap.classList.remove('is-animating');
          panelsWrap.style.height = '';
          panelsWrap.style.removeProperty('--v3t-enter-from');
          panelsWrap.style.removeProperty('--v3t-leave-to');
          animating = false;
        }, 360);
      }

      // 点击
      navBtns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          updateNavOverflow();
          scrollBtnIntoView(btn);
          activateTab(i);
          btn.focus();
        });
      });

      // 键盘方向键 + Tab 导航
      navBtns.forEach(function (btn) {
        btn.addEventListener('keydown', function (e) {
          var total = navBtns.length;
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            activateTab((currentIndex + 1) % total);
            scrollBtnIntoView(navBtns[currentIndex]);
            navBtns[currentIndex].focus();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            activateTab((currentIndex - 1 + total) % total);
            scrollBtnIntoView(navBtns[currentIndex]);
            navBtns[currentIndex].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            activateTab(0);
            scrollBtnIntoView(navBtns[0]);
            navBtns[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            activateTab(total - 1);
            scrollBtnIntoView(navBtns[total - 1]);
            navBtns[total - 1].focus();
          } else if (e.key === 'Tab' && !e.shiftKey) {
            // Tab 键：将焦点从 tab button 移入当前激活的 panel（WAI-ARIA Tabs Pattern）
            var activePanel = panels[currentIndex];
            if (activePanel) {
              e.preventDefault();
              activePanel.focus();
            }
          }
        });
      });

      // 初始化：第一个面板直接显示，无动画
      panels[0].classList.add('is-active');
      bindImageSkeletons(sectionEl);
      updateActiveIndicator(true);
      updateNavOverflow();
      setupViewportPreload();
      window.addEventListener('resize', function () {
        if (rafOverflow) cancelAnimationFrame(rafOverflow);
        rafOverflow = requestAnimationFrame(function () {
          rafOverflow = 0;
          updateNavOverflow();
          updateActiveIndicator(true);
        });
      });
    }

    function init() {
      // 通过 data-initialized 标记防止同一元素被重复初始化
      document.querySelectorAll('.v3-tabs').forEach(function (el) {
        if (el.dataset.v3tabsInit) return;
        el.dataset.v3tabsInit = '1';
        initTabsSection(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.detail || !e.detail.sectionId) return;
      var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId + '-content');
      if (sectionEl && sectionEl.classList.contains('v3-tabs') && !sectionEl.dataset.v3tabsInit) {
        sectionEl.dataset.v3tabsInit = '1';
        initTabsSection(sectionEl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-article-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.YGBlogArticleBanner) {
    window.YGBlogArticleBanner = {
      init: function (root) {
        if (!window.ygProductActionButtons) return;

        var scope = root || document;
        var sections =
          scope.matches && scope.matches('[data-yg-blog-article-banner]')
            ? [scope]
            : scope.querySelectorAll('[data-yg-blog-article-banner]');

        sections.forEach(function (section) {
          window.ygProductActionButtons.bindSection(section, {
            addSelector: '[data-yg-blog-kv-add]',
            buySelector: '[data-yg-blog-kv-buy-disabled]',
            productFormSelector: '[data-yg-blog-kv-product-form]',
          });
        });
      },
    };

    document.addEventListener('shopify:section:load', function (event) {
      window.YGBlogArticleBanner.init(event.target);
    });
  }

  window.YGBlogArticleBanner.init(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-article-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var isFirstLoad = !window.YGBlogArticleMain;
    window.YGBlogArticleMain = {
      getHeaderOffset: function () {
        if (window.YGBlogArticleNav && typeof window.YGBlogArticleNav.getHeaderOffset === 'function') {
          return window.YGBlogArticleNav.getHeaderOffset();
        }

        if (window.YGBlogArticleNav && typeof window.YGBlogArticleNav.getStickyStackOffset === 'function') {
          return window.YGBlogArticleNav.getStickyStackOffset();
        }

        var styles = getComputedStyle(document.documentElement);
        var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
        var announcement = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
        var enableHeader = parseFloat(styles.getPropertyValue('--enable-sticky-header'));
        var enableAnnouncement = parseFloat(styles.getPropertyValue('--enable-sticky-announcement-bar'));

        if (isNaN(enableHeader)) enableHeader = 1;
        if (isNaN(enableAnnouncement)) enableAnnouncement = 0;

        return header * enableHeader + announcement * enableAnnouncement;
      },

      /*
        CSS already uses theme sticky-stack vars. Only override when measured
        header offset differs (vars lag or header taller than published height).
      */
      updateStickyTop: function (root) {
        if (!root) return;

        var stickyGap = 16;
        var offset = Math.max(0, Math.round(window.YGBlogArticleMain.getHeaderOffset()) + stickyGap);
        if (offset <= stickyGap) {
          root.style.removeProperty('--yg-blog-article-sidebar-sticky-top');
          return;
        }

        root.style.setProperty('--yg-blog-article-sidebar-sticky-top', offset + 'px');
      },

      bind: function (root) {
        if (!root) return;

        var api = window.YGBlogArticleMain;

        /* Always (re)bind subscribe — HTML/dialog may change across theme syncs. */
        api.bindKlaviyoFormVisibility(root);
        api.bindEmailSubscribe(root);

        if (root.dataset.ygBlogArticleMainInitialized === 'true') return;

        var frameId = null;

        function requestUpdate() {
          if (frameId !== null) return;
          frameId = window.requestAnimationFrame(function () {
            frameId = null;
            api.updateStickyTop(root);
          });
        }

        root.dataset.ygBlogArticleMainInitialized = 'true';
        api.enhanceTables(root);
        api.enhanceFaqs(root);
        api.updateStickyTop(root);
        /* Resize only — CSS vars cover sticky top during scroll. */
        window.addEventListener('resize', requestUpdate);
        root.ygBlogArticleMainCleanup = function () {
          if (typeof root.ygBlogEmailSubscribeClose === 'function') {
            root.ygBlogEmailSubscribeClose();
          }
          if (typeof root.ygBlogKlaviyoFormCleanup === 'function') {
            root.ygBlogKlaviyoFormCleanup();
          }
          window.removeEventListener('resize', requestUpdate);
          if (frameId !== null) window.cancelAnimationFrame(frameId);
          root.ygBlogArticleMainCleanup = null;
          root.ygBlogEmailSubscribeClose = null;
          root.ygBlogKlaviyoFormCleanup = null;
          delete root.dataset.ygBlogEmailSubscribeDelegated;
          delete root.dataset.ygBlogKlaviyoWatch;
        };
      },

      bindKlaviyoFormVisibility: function (root) {
        if (!root || root.dataset.ygBlogKlaviyoWatch === 'true') return;

        var slot = root.querySelector('[data-yg-blog-email-subscribe-slot]');
        var entry = root.querySelector('[data-yg-blog-email-subscribe-entry-slot]');
        if (!slot && !entry) return;

        if (window.Shopify && window.Shopify.designMode) return;

        root.dataset.ygBlogKlaviyoWatch = 'true';

        var formId = (slot && slot.getAttribute('data-klaviyo-form-id')) || (entry && entry.getAttribute('data-klaviyo-form-id')) || '';
        var selector = formId ? '.klaviyo-form-' + formId : '[class*="klaviyo-form-"]';
        var hideTimer = 0;
        var observer = null;

        function collectFormNodes() {
          var nodes = [];
          function addFrom(scope) {
            if (!scope || !scope.querySelectorAll) return;
            scope.querySelectorAll(selector).forEach(function (node) {
              if (nodes.indexOf(node) === -1) nodes.push(node);
            });
          }
          addFrom(root);
          addFrom(document);
          return nodes;
        }

        function formHasContent() {
          return collectFormNodes().some(function (node) {
            if (!node) return false;
            if (node.querySelector('iframe, form, input, button, textarea, select')) return true;
            return node.children.length > 0 || Boolean((node.textContent || '').trim());
          });
        }

        function setHidden(node, hide) {
          if (!node) return;
          node.hidden = hide;
          if (hide) node.setAttribute('hidden', '');
          else node.removeAttribute('hidden');
        }

        function syncVisibility() {
          var hide = !formHasContent();
          setHidden(slot, hide);
          setHidden(entry, hide);
        }

        function stopWatching() {
          if (hideTimer) {
            window.clearTimeout(hideTimer);
            hideTimer = 0;
          }
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          document.removeEventListener('klaviyoForms', onKlaviyoForms);
        }

        function onKlaviyoForms() {
          syncVisibility();
          if (formHasContent()) stopWatching();
        }

        observer = new MutationObserver(function () {
          syncVisibility();
          if (formHasContent()) stopWatching();
        });

        [slot, entry, root].concat(collectFormNodes()).forEach(function (node) {
          if (!node) return;
          observer.observe(node, { childList: true, subtree: true });
        });

        document.addEventListener('klaviyoForms', onKlaviyoForms);
        syncVisibility();
        hideTimer = window.setTimeout(function () {
          hideTimer = 0;
          syncVisibility();
          if (formHasContent()) stopWatching();
        }, 8000);

        root.ygBlogKlaviyoFormCleanup = function () {
          stopWatching();
          delete root.dataset.ygBlogKlaviyoWatch;
          root.ygBlogKlaviyoFormCleanup = null;
        };
      },

      bindEmailSubscribe: function (root) {
        var dialog =
          root.querySelector('[data-yg-blog-email-subscribe-dialog]') ||
          document.querySelector(
            '.yg-blog-email-subscribe-dialog[data-section-id="' + (root.dataset.sectionId || '') + '"]'
          ) ||
          document.querySelector('[data-yg-blog-email-subscribe-dialog]');
        var triggers = root.querySelectorAll('[data-yg-blog-email-subscribe-trigger]');
        if (!dialog || !triggers.length) return;

        if (!dialog.getAttribute('data-section-id') && root.dataset.sectionId) {
          dialog.setAttribute('data-section-id', root.dataset.sectionId);
        }

        var previouslyFocused = null;
        var homeParent = dialog.parentNode === document.body ? root : dialog.parentNode;
        var homeNextSibling = dialog.parentNode === document.body ? null : dialog.nextSibling;

        function openDialog(trigger) {
          previouslyFocused = trigger || document.activeElement;

          if (dialog.parentNode !== document.body) {
            homeParent = dialog.parentNode;
            homeNextSibling = dialog.nextSibling;
            document.body.appendChild(dialog);
          }

          dialog.removeAttribute('hidden');
          dialog.hidden = false;
          document.body.classList.add('yg-blog-email-subscribe-dialog-open');

          var closeBtn = dialog.querySelector(
            '.yg-blog-email-subscribe-dialog__close[data-yg-blog-email-subscribe-dialog-close]'
          );
          if (closeBtn) closeBtn.focus();

          document.dispatchEvent(
            new CustomEvent('yg-blog:email-subscribe-open', {
              bubbles: true,
              detail: { trigger: previouslyFocused, dialog: dialog },
            })
          );
        }

        function closeDialog() {
          if (dialog.hasAttribute('hidden') && dialog.hidden) return;

          dialog.setAttribute('hidden', '');
          dialog.hidden = true;
          document.body.classList.remove('yg-blog-email-subscribe-dialog-open');

          if (homeParent && dialog.parentNode === document.body) {
            if (homeNextSibling && homeNextSibling.parentNode === homeParent) {
              homeParent.insertBefore(dialog, homeNextSibling);
            } else {
              homeParent.appendChild(dialog);
            }
          }

          document.dispatchEvent(
            new CustomEvent('yg-blog:email-subscribe-close', {
              bubbles: true,
              detail: { dialog: dialog },
            })
          );

          if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
            previouslyFocused.focus();
          }
          previouslyFocused = null;
        }

        root.ygBlogEmailSubscribeClose = closeDialog;
        root.ygBlogEmailSubscribeOpen = openDialog;

        triggers.forEach(function (trigger) {
          trigger.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            openDialog(trigger);
          };
        });

        dialog.querySelectorAll('[data-yg-blog-email-subscribe-dialog-close]').forEach(function (el) {
          el.onclick = function (event) {
            event.preventDefault();
            closeDialog();
          };
        });

        if (dialog.dataset.ygBlogEmailSubscribeEscBound !== 'true') {
          dialog.dataset.ygBlogEmailSubscribeEscBound = 'true';
          document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && !dialog.hidden) {
              event.preventDefault();
              closeDialog();
            }
          });
        }
      },

      enhanceTables: function (root) {
        root.querySelectorAll('[data-post-content] table').forEach(function (table) {
          if (table.parentElement && table.parentElement.classList.contains('yg-blog-article-table-scroll')) return;

          var scroller = document.createElement('div');
          scroller.className = 'yg-blog-article-table-scroll';
          scroller.setAttribute('role', 'region');
          scroller.setAttribute('aria-label', root.dataset.tableLabel);
          scroller.setAttribute('tabindex', '0');
          table.parentNode.insertBefore(scroller, table);
          scroller.appendChild(table);
        });
      },

      enhanceFaqs: function (root) {
        root.querySelectorAll('.blog-article-faq-container').forEach(function (container, faqIndex) {
          if (container.dataset.ygBlogArticleFaqInitialized === 'true') return;

          var headings = Array.prototype.filter.call(container.children, function (child) {
            return child.tagName === 'H3';
          });

          headings.forEach(function (heading, itemIndex) {
            var item = document.createElement('div');
            var panel = document.createElement('div');
            var panelInner = document.createElement('div');
            var button = document.createElement('button');
            var uid = root.dataset.sectionId + '-faq-' + faqIndex + '-' + itemIndex;
            var clipId = uid + '-chevron-clip';
            var iconTemplate = document.createElement('template');
            iconTemplate.innerHTML =
              '<svg class="yg-blog-article-faq__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<g clip-path="url(#' +
              clipId +
              ')">' +
              '<path d="M18.0352 15.2L12.9708 10.1356C12.385 9.54984 11.4353 9.54984 10.8495 10.1356L5.78516 15.2" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</g>' +
              '<defs><clipPath id="' +
              clipId +
              '"><rect width="14" height="7" fill="white" transform="translate(5.03516 8.94629)"/></clipPath></defs>' +
              '</svg>';
            var icon = iconTemplate.content.firstElementChild;

            item.className = 'yg-blog-article-faq__item is-expanded';
            heading.classList.add('yg-blog-article-faq__heading');
            heading.parentNode.insertBefore(item, heading);
            item.appendChild(heading);

            button.className = 'yg-blog-article-faq__button';
            button.type = 'button';
            button.id = uid + '-button';
            button.setAttribute('aria-expanded', 'true');
            button.setAttribute('aria-controls', uid + '-panel');
            while (heading.firstChild) button.appendChild(heading.firstChild);

            button.appendChild(icon);
            heading.appendChild(button);

            panel.className = 'yg-blog-article-faq__panel';
            panel.id = uid + '-panel';
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', button.id);
            panel.setAttribute('aria-hidden', 'false');
            panelInner.className = 'yg-blog-article-faq__panel-inner';
            panel.appendChild(panelInner);

            while (item.nextSibling && !(item.nextSibling.nodeType === 1 && item.nextSibling.tagName === 'H3')) {
              panelInner.appendChild(item.nextSibling);
            }
            item.appendChild(panel);

            button.addEventListener('click', function () {
              var expanded = button.getAttribute('aria-expanded') === 'true';
              var nextExpanded = !expanded;
              button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
              panel.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');
              item.classList.toggle('is-expanded', nextExpanded);

              if (nextExpanded) {
                panel.removeAttribute('inert');
              } else {
                panel.setAttribute('inert', '');
              }
            });
          });

          container.dataset.ygBlogArticleFaqInitialized = 'true';
        });
      },

      initProductSwipers: function (root) {
        if (!window.Swiper) return;

        root.querySelectorAll('[data-yg-blog-article-product-swiper]').forEach(function (swiperElement) {
          if (swiperElement.dataset.ygBlogArticleSwiperInitialized === 'true') return;

          swiperElement.ygBlogArticleSwiper = new window.Swiper(swiperElement, {
            slidesPerView: 1.5,
            spaceBetween: 8,
            watchOverflow: true,
            /* PC: center the row when only 2–3 cards (fewer than slidesPerView). */
            centerInsufficientSlides: true,
            breakpoints: {
              768: {
                slidesPerView: 3.1,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
              1024: {
                slidesPerView: 3.5,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
              1441: {
                slidesPerView: 4,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
            },
          });
          swiperElement.dataset.ygBlogArticleSwiperInitialized = 'true';
        });
      },

      destroy: function (scope) {
        var context = scope || document;
        var roots =
          context.matches && context.matches('[data-yg-blog-article-main]')
            ? [context]
            : context.querySelectorAll('[data-yg-blog-article-main]');

        roots.forEach(function (root) {
          if (typeof root.ygBlogArticleMainCleanup === 'function') {
            root.ygBlogArticleMainCleanup();
          }

          root.querySelectorAll('[data-yg-blog-article-product-swiper]').forEach(function (swiperElement) {
            if (swiperElement.ygBlogArticleSwiper) {
              swiperElement.ygBlogArticleSwiper.destroy(true, true);
              swiperElement.ygBlogArticleSwiper = null;
            }
            delete swiperElement.dataset.ygBlogArticleSwiperInitialized;
          });

          delete root.dataset.ygBlogArticleMainInitialized;
        });
      },

      init: function (scope) {
        var context = scope || document;
        var roots =
          context.matches && context.matches('[data-yg-blog-article-main]')
            ? [context]
            : context.querySelectorAll('[data-yg-blog-article-main]');

        roots.forEach(function (root) {
          window.YGBlogArticleMain.bind(root);
          window.YGBlogArticleMain.initProductSwipers(root);
        });
      },
    };

    if (isFirstLoad) {
      document.addEventListener('shopify:section:load', function (event) {
        window.YGBlogArticleMain.init(event.target);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        window.YGBlogArticleMain.destroy(event.target);
      });

      window.addEventListener(
        'load',
        function () {
          window.YGBlogArticleMain.init(document);
        },
        { once: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.YGBlogArticleMain.init(document);
      });
    } else {
      window.YGBlogArticleMain.init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-gallery-item"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGGallerySlide extends HTMLElement {
      constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.initEntranceAnimation = this.initEntranceAnimation.bind(this);
        this.mobileSwiper = null;
        this.swiperCheckTimer = null;
        this.entranceTween = null;
      }

      get items() {
        return this.querySelectorAll('.yg-gallery-desktop .yg-gallery-item');
      }

      connectedCallback() {
        this.handleResize();
        this.initEntranceAnimation();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.removeHoverListeners();
        this.clearSwiperCheckTimer();
        this.destroyMobileSwiper();

        if (this.entranceTween) {
          this.entranceTween.kill();
          this.entranceTween = null;
        }
      }

      handleResize() {
        if (window.innerWidth >= 750) {
          this.clearSwiperCheckTimer();
          this.destroyMobileSwiper();
          this.clearActiveState();
          this.addHoverListeners();
        } else {
          this.removeHoverListeners();
          this.clearActiveState();
          this.ensureMobileSwiper();
        }
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleMouseEnter);
          item.removeEventListener('mouseleave', this.handleMouseLeave);
          item.addEventListener('mouseenter', this.handleMouseEnter);
          item.addEventListener('mouseleave', this.handleMouseLeave);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleMouseEnter);
          item.removeEventListener('mouseleave', this.handleMouseLeave);
        });
      }

      handleMouseEnter(e) {
        this.clearActiveState();
        e.currentTarget.classList.add('active');
      }

      handleMouseLeave() {
        this.clearActiveState();
      }

      clearActiveState() {
        this.items.forEach((item) => item.classList.remove('active'));
      }

      initEntranceAnimation() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.warn('[YGGallerySlide] gsap or ScrollTrigger not ready');
          return;
        }

        gsap.registerPlugin(ScrollTrigger);

        if (this.entranceTween) {
          this.entranceTween.kill();
          this.entranceTween = null;
        }

        ScrollTrigger.getAll().forEach((trigger) => {
          if (trigger.vars && trigger.vars.trigger === this) {
            trigger.kill();
          }
        });

        gsap.set(this, {
          y: 50,
          force3D: true,
        });

        this.entranceTween = gsap.to(this, {
          y: 0,
          duration: 0.9,
          ease: 'power2.out',
          overwrite: true,
          force3D: true,
          onStart: () => {
            console.log('[YGGallerySlide] animation started', {
              rect: this.getBoundingClientRect(),
              computedTransform: window.getComputedStyle(this).transform,
            });
          },
          onComplete: () => {
            console.log('[YGGallerySlide] animation completed', {
              rect: this.getBoundingClientRect(),
              transform: this.style.transform,
              computedTransform: window.getComputedStyle(this).transform,
            });
          },
          scrollTrigger: {
            trigger: this,
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true,
            onEnter: (self) => {
              console.log('[YGGallerySlide] ScrollTrigger onEnter', {
                progress: self.progress,
                start: self.start,
                end: self.end,
                rect: this.getBoundingClientRect(),
              });
            },
            onRefresh: (self) => {
              console.log('[YGGallerySlide] ScrollTrigger onRefresh', {
                start: self.start,
                end: self.end,
                rect: this.getBoundingClientRect(),
              });
            },
          },
        });

        ScrollTrigger.refresh();
      }

      ensureMobileSwiper() {
        if (this.mobileSwiper || window.innerWidth >= 750) {
          return;
        }

        if (typeof Swiper !== 'undefined') {
          this.initMobileSwiper();
          return;
        }

        if (this.swiperCheckTimer) {
          return;
        }

        this.swiperCheckTimer = setInterval(() => {
          if (typeof Swiper !== 'undefined' && window.innerWidth < 750) {
            this.clearSwiperCheckTimer();
            this.initMobileSwiper();
          }
        }, 100);
      }

      clearSwiperCheckTimer() {
        if (!this.swiperCheckTimer) {
          return;
        }

        clearInterval(this.swiperCheckTimer);
        this.swiperCheckTimer = null;
      }

      initMobileSwiper() {
        if (window.innerWidth >= 750 || this.mobileSwiper || typeof Swiper === 'undefined') {
          return;
        }

        const swiperEl = this.querySelector('.yg-gallery-mobile-swiper');
        const paginationEl = this.querySelector('.yg-gallery-mobile-pagination');
        const nextEl = this.querySelector('.yg-gallery-mobile-next');
        const prevEl = this.querySelector('.yg-gallery-mobile-prev');

        if (!swiperEl || !paginationEl || !nextEl || !prevEl) {
          return;
        }

        this.mobileSwiper = new Swiper(swiperEl, {
          slidesPerView: 1.1,
          spaceBetween: 12,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        });
      }

      destroyMobileSwiper() {
        if (!this.mobileSwiper) {
          return;
        }

        this.mobileSwiper.destroy(true, true);
        this.mobileSwiper = null;
      }
    }

    if (!window.customElements.get('yg-gallery-slide')) {
      window.customElements.define('yg-gallery-slide', YGGallerySlide);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nasal-aspirators-experts"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var elementName = 'yg-nasal-aspirators-experts-mobile'

    if (customElements.get(elementName)) return

    customElements.define(
      elementName,
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-expert-index]'))
          this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-expert-card]'))
          this.activeIndex = Number(this.dataset.initialIndex || 0)

          if (!this.buttons.length) return

          this.buttons.forEach(
            function (button) {
              button.addEventListener(
                'click',
                function () {
                  this.setActive(Number(button.dataset.expertIndex), true)
                }.bind(this)
              )
            }.bind(this)
          )

          this.setActive(this.activeIndex, false)
        }

        setActive(index, shouldFocus) {
          var count = this.buttons.length
          if (!count) return

          this.activeIndex = Math.max(0, Math.min(index, count - 1))
          var previousIndex = (this.activeIndex - 1 + count) % count
          var nextIndex = (this.activeIndex + 1) % count

          this.buttons.forEach(
            function (button, buttonIndex) {
              var isActive = buttonIndex === this.activeIndex
              var isVisible = count < 3 || buttonIndex === this.activeIndex || buttonIndex === previousIndex || buttonIndex === nextIndex
              button.hidden = !isVisible
              button.classList.toggle('is-active', isActive)
              button.classList.toggle('is-left', !isActive && buttonIndex === previousIndex)
              button.classList.toggle('is-right', !isActive && buttonIndex === nextIndex)
              button.setAttribute('aria-selected', isActive ? 'true' : 'false')
            }.bind(this)
          )

          this.cards.forEach(
            function (card, cardIndex) {
              card.hidden = cardIndex !== this.activeIndex
            }.bind(this)
          )

          if (shouldFocus) this.buttons[this.activeIndex].focus()
        }
      }
    )
  })()

  } catch(e) { console.error(e); }
})();
})();
